import { render, staticRenderFns } from "./CourseGraph.vue?vue&type=template&id=e4edb69a"
import script from "./CourseGraph.vue?vue&type=script&lang=js"
export * from "./CourseGraph.vue?vue&type=script&lang=js"
import style0 from "./CourseGraph.vue?vue&type=style&index=0&id=e4edb69a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports